import { useEffect } from "react";
import { AlertTriangle, X } from "lucide-react";

export default function PreviewBanner({ lang, status, updatedAt }) {
  useEffect(() => {
    window.__IS_PREVIEW__ = true; // analytics can exclude preview traffic
    return () => { window.__IS_PREVIEW__ = false; };
  }, []);

  const exit = () => {
    const u = new URL(window.location.href);
    u.searchParams.delete("preview");
    window.location.href = u.pathname;
  };

  return (
    <div
      data-testid="preview-banner"
      className="fixed top-0 inset-x-0 z-[200] bg-amber-400 text-black text-xs sm:text-sm font-semibold flex items-center justify-center gap-3 px-4 py-2 shadow-lg"
    >
      <span className="inline-flex items-center gap-2">
        <AlertTriangle size={14} />
        PREVIEW · {(lang || "").toUpperCase()} · {(status || "").toUpperCase()} · NOT PUBLISHED
      </span>
      {updatedAt && (
        <span className="hidden md:inline opacity-70">· Updated {new Date(updatedAt).toLocaleString()}</span>
      )}
      <button onClick={exit} data-testid="exit-preview" className="inline-flex items-center gap-1 underline hover:no-underline">
        <X size={12} /> Exit Preview
      </button>
    </div>
  );
}
